/**
 * Resets the entire decision tree form
 */
function resetEntireTree() {
    const items = document.querySelectorAll('.decision-tree__item');

    // hide questions
    items.forEach((item, index) => {
        if (index > 0) {
            item.classList.remove('decision-tree__item--active');
        }
    });

    // hide response
    const responseElem = document.querySelector('.decision-tree-apply');
    if (responseElem && !responseElem.classList.contains('hidden')) {
        responseElem.classList.add('hidden');
    }

    // clear form
    const form = document.querySelector('.descision-tree__form');
    if (form) {
        form.reset();
    }

    // scroll back to top of tree
    const scrollPoint = document.querySelector('.descision-tree__form');
    if (scrollPoint) {
        const offset = 20;
        const formTop = scrollPoint.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: formTop - offset, behavior: 'smooth' });
    }

    // reset button
    toggleResetButtonState();
}

/**
 * Enables/disables reset button depending on selection
 */
function toggleResetButtonState() {
    const resetButton = document.querySelector('.decision-tree__reset');
    const selects = document.querySelectorAll('.descision-tree__form select');

    const hasSelection = Array.from(selects).some(select => select.selectedIndex > 0);

    resetButton.disabled = !hasSelection;
}

document.addEventListener("DOMContentLoaded", function () {
    const resetButton = document.querySelector('.decision-tree__reset');
    const selectFields = document.querySelectorAll('.descision-tree__form select');

    if (resetButton) {
        resetButton.addEventListener('click', resetEntireTree);
    }

    if (selectFields.length > 0) {
        selectFields.forEach(select => {
            select.addEventListener('change', toggleResetButtonState);
        });
        toggleResetButtonState();
    }
});





